import i18next from 'i18next';
import { numberValidate } from './regex';

export const validate = values => {
  const errors = {};

  //date
  if (!values.dates.start_date && values.dates.end_date) {
    const start_date = i18next.t('specify_start_date');
    errors.dates = { start_date };
  } else if (values.dates.start_date && !values.dates.end_date) {
    const end_date = i18next.t('specify_end_date');
    errors.dates = { end_date };
  }

  //average
  if (values.accural.average && !numberValidate(values.accural.average)) {
    errors.accural = { average: i18next.t('value_must_be_number') };
  } else if (values.accural.condition.name && !values.accural.average) {
    errors.accural = { average: i18next.t('enter_value') };
  }

  //condition
  if (values.accural.average && !values.accural.condition.name) {
    errors.accural = { condition: { name: i18next.t('select_operator') } };
  }

  return errors;
};
